export const inspectTable = [
  {
    id: 1,
    content:
      "기계톱 사용 전에 볼트･너트 체결상태, 톱날, 방호장치* 상태, 누유여부 등을 확인한 후 작업을 시작하는가?\n" +
      "* 전방 방호판, 체인 브레이크 조작판, 체인잡이, 진동방지장치 등",
    is_checked: "",
  },
  {
    id: 2,
    content:
      "기계톱 시동 전 주변에 근로자와 연료, 장애물이 없는지 확인하고, 지면에서 기계톱을 작동하는가?",
    is_checked: "",
  },
  {
    id: 3,
    content:
      "킥백(Kick Back)현상*을 방지하기 위해 기계톱 톱날 회전 방향에 맞는 절단 방법을 준수하여 작업하는가?\n" +
      "* 회전하는 톱체인(가이드바) 끝의 상단부분이 어떤 물체에 닿아서 체인톱이 작업자 쪽으로 튀는 현상",
    is_checked: "",
  },
  {
    id: 4,
    content: "연료 용기는 연료누출이 없고, 위험물질 경고표지를 부착하는가?",
    is_checked: "",
  },
  {
    id: 5,
    content:
      "작업자에게 안전모, 보안경, 방진장갑 등 작업에 적절한 보호구를 지급･착용토록 하는가?",
    is_checked: "",
  },
  {
    id: 6,
    content:
      "기계톱 작업 시 섬유조직이 톱날의 회전을 멈추게 할 수 있는 안전바지및 무릎보호대를 착용하는가?",
    is_checked: "",
  },
  {
    id: 7,
    content:
      "다른 지점으로 이동하거나, 톱을 사용하지 않을 때는 체인톱날이 돌지않게 체인 브레이크를 사용하고, 먼 거리 이동 시 엔진을 정지하고 안전덮개를 부착하는가?",
    is_checked: "",
  },
  {
    id: 8,
    content:
      "기계톱의 정비･청소･급유 등을 할 때 반드시 기계톱의 운전을 정지한 후에 작업을 실시하는가?",
    is_checked: "",
  },
  {
    id: 9,
    content:
      "작업 전 작업자 및 신호수가 작업구역, 작업 순서 및 방법, 신호체계 등을 숙지하였는지 확인한 후 작업을 시작하는가?",
    is_checked: "",
  },
  {
    id: 10,
    content:
      "기계톱에 설치된 방호장치를 임의로 해체하거나 기능을 정지하지 않는가?",
    is_checked: "",
  },
];
